import React from "react";
import { BreadcrumbI } from "../../types-interfaces/interfaces";

interface BreadcrumbProps extends React.HTMLAttributes<HTMLElement>{  
  breadcrumbs?: Array<BreadcrumbI> | undefined
}

class Breadcrumb extends React.Component<BreadcrumbProps> {
  render() {
    return (
      <div className={this.props.className}>
        <div>
          <a href="/">
            Home
          </a>
        </div>
        {this.props.breadcrumbs?.map((breadcrumb, index) =>
        <div key={'d' + index}>
          <a
            key={'s' + index}
            href={breadcrumb.url}
            style={{ paddingRight:"10px"}}>
              /
          </a>
          <a
            key={'a' + index}
            href={breadcrumb.url}
          >
            {breadcrumb.name}
          </a>
        </div>
        )}
      </div>
    );
  }
}

export default Breadcrumb;